import Vue from 'vue';
import Component from 'vue-class-component';
import Lottie from 'vue-lottie';

import dayjs from 'dayjs';

import BbModal from 'common/components/BbModal';
import Step from 'components/Reminders/Step/Step.vue';
import FinalStep from 'components/Reminders/FinalStep/FinalStep.vue';

import AddReminderMutation from 'assets/graphql/mutations/reminder/AddReminderMutation.graphql';
import EstadoSuccess from 'assets/icons/estado_success_icon.svg';
import FirstStep from 'assets/icons/first_step_reminder.svg';
import SecondStep from 'assets/icons/second_step_reminder.svg';
import ThirdStep from 'assets/icons/third_step_reminder.svg';
import * as check from 'assets/lotties/check_01.json';

@Component({
  components: {
    BbModal,
    Step,
    FinalStep,
    Lottie,
  },
  props: {
    viewStep: {
      type: String,
    },
  },
})
export default class RemindersComponent extends Vue {
  isLoading = false;
  error = false;
  showReminderPopover = false;
  stepInComming = this.viewStep;

  icons = {
    statusOk: EstadoSuccess,
    firstStep: FirstStep,
    secondStep: SecondStep,
    thirdStep: ThirdStep,
  };

  lotties = {
    animationData: check.default,
  };

  popoverText = {
    first: 'Primer recordatorio guardado.',
    second: 'Segundo recordatorio guardado.',
    third: 'Tercer recordatorio guardado.',
  };

  commonSteps = {
    name: {
      label: 'Nombre',
      value: '',
    },
    occasion: {
      label: 'Ocasión',
      value: '',
    },
    date: {
      label: 'Fecha especial',
      value: '',
    },
    button: 'Guardar',
  };
  first = {
    title: 'Primer recordatorio',
    ...this.copyObjectWithoutReference(this.commonSteps),
    nextStep: () => this.toogleRemindersModalWithAddReminder('second'),
  };
  second = {
    title: 'Segundo recordatorio',
    ...this.copyObjectWithoutReference(this.commonSteps),
    nextStep: () => this.toogleRemindersModalWithAddReminder('third'),
  };
  third = {
    title: 'Tercer recordatorio',
    ...this.copyObjectWithoutReference(this.commonSteps),
    nextStep: () => this.toogleRemindersModalWithAddReminder('final'),
  };

  final = {
    title: `¡Genial! Ya ${this.$translate(
      'tenés',
    )} tus 3 recordatorios guardados`,
    content: `${this.$translate(
      'Podés',
    )} usar tu 10% de descuento aplicado en tu carrito.`,
    description: `¿${this.$translate(
      'Sabés',
    )} qué les gustaría que les regalen?`,
    button: `¡${this.$translate('Preguntales')} ahora!`,
    buttonSecondary: `${this.$translate('Preguntales')} más tarde`,
    closeModal: () => this.handleRemindersModalView(),
    goToAskPreference: () => this.$router.push({ name: 'regalendario' }),
  };

  remindersSteps = {
    first: this.first,
    second: this.second,
    third: this.third,
    final: this.final,
  };

  copyObjectWithoutReference(obj) {
    return JSON.parse(JSON.stringify(obj));
  }

  handleRemindersModalView() {
    this.$emit('handleRemindersModalView');
  }

  async toogleRemindersModalWithAddReminder(step) {
    this.isLoading = true;
    this.miliseconds = 2000;

    const { occasion, date, name } = this.remindersSteps[this.viewStep];

    const mutateConfig = {
      mutation: AddReminderMutation,
      variables: {
        input: {
          name: name.value,
          occasion: occasion.value,
          date: dayjs(date.value, 'DD/MM/YYYY').format('YYYY-MM-DD'),
        },
      },
    };
    const {
      data: { add_reminder },
    } = await this.$apollo.mutate(mutateConfig);

    if (add_reminder.ok) {
      this.showReminderPopover = true;
      this.stepInComming = step;
      this.closeReminderPopoverAutomatic(this.miliseconds);
    } else {
      this.error = true;
      this.showReminderPopover = true;
    }
  }

  toggleReminderPopover() {
    this.showReminderPopover = false;
    this.isLoading = false;
    this.$emit('nextStep', this.stepInComming);
  }

  closeReminderPopoverAutomatic(miliseconds) {
    setTimeout(() => {
      this.toggleReminderPopover();
    }, miliseconds);
  }
}
